<script>
	import client from "../../services/client";
	import { convertDateTime } from "../../services/helpers";
	import {
		loading,
		createBlackoutData,
		blackoutCarData,
		initialEditBlackout,
		editBlackoutData,
	} from "../../store/store";
	import CreateBlackoutForm from "./CreateBlackoutForm.svelte";
	export let blackoutId;
	import { extractErrorMessage } from "../../utils/misc";

	let data = [];

	async function fetchCars() {
		blackoutCarData.set("");
		loading.set(true);
		try {
			const res = await client(`/v1/blackouts/${blackoutId}`, {
				method: "GET",
				version: "Vehicle",
			});
			// ;
			data = res.data;
			const cars = res.data.blackoutVehicles.map((car) => {
				return {
					id: car.vehicleId,
					vehicleModelName: car.modelName,
					plateNumber: car.plateNumber,
					vehicleMakeName: car.makeName,
					status: car.status,
					activeFrom: car.activeFrom,
					activeTo: car.activeTo,
					carParkId: car.carparkId,
					carParkName: car.carparkName,
				};
			});
			createBlackoutData.set({
				id: data.id,
				blackoutStartDate: convertDateTime(data.blackoutStartDate),
				blackoutEndDate: convertDateTime(data.blackoutEndDate),
				blackoutVehicles: data.blackoutVehicles,
				reason: data.reason,
				status: data.status,
			});

			editBlackoutData.set({
				id: data.id,
				stats: true,
			});
			blackoutCarData.set(cars);
			loading.set(false);
		} catch (error) {
			loading.set(false);
			extractErrorMessage(error);
		}
	}

	if ($initialEditBlackout == 0) {
		fetchCars();
	}

	$: editData = $createBlackoutData;
</script>

{#if !editData}
	<CreateBlackoutForm />
{:else}
	<CreateBlackoutForm {blackoutId} />
{/if}
